export default {
  filterData : {
    Products: {
      label: 'Produkte',
      allFilterLabel: "Alle Produkte",
      items: [
        { name: "Citrix ADC", id: "citrix_adc" },
        { name: "Citrix Analytics for Performance", id: "citrix_analytics_for_performance" },
        { name: "Citrix Analytics for Security", id: "citrix_analytics_for_security" },     
        { name: "Citrix App Delivery and Security Service", id:"citrix_app_delivery_and_security_service"},
        { name: "Citrix Application Delivery Management", id: "citrix_application_delivery_management" },
        { name: "Citrix Content Collaboration", id: "citrix_content_collaboration" },
        { name: "Citrix DaaS (formerly Citrix Virtual Apps and Desktops service)", id: "citrix_virtual_apps_and_desktops" },
        {
          name: "Citrix DaaS Standard for Azure",
          id: "citrix_virtual_apps_and_desktops_standard_for_azure"
        },
        {
          name: "Citrix DaaS Standard for Google Cloud",
          id: "citrix_daas_standard_for_google_cloud",
        },
        { name: "Citrix Endpoint Management", id: "citrix_endpoint_management" },
        { name: "Citrix Gateway", id: "citrix_gateway" },
        { name: "Citrix SD-WAN", id: "citrix_sd_wan" },
        { name: "Citrix Secure Internet Access", id: "citrix_secure_internet_access" },
        { name: "Citrix Secure Private Access", id: "citrix_secure_private_access" },
        { name: "Citrix Virtual Apps and Desktops", id: "citrix_virtual_apps_desktops" },
        { name: "Citrix Web App and API Protection", id: "citrix_web_app_and_api_protection" },
        { name: "Citrix Workspace", id: "citrix_workspace" },
      ],
    },
    Topics: {
      label: "Themen",
      allFilterLabel: "Alle Themen",
      items: [
        { name: "Zugriffsmanagement", id: "Access management" },
        { name: "Analyse und Monitoring", id: "Analytics and monitoring" },
        { name: "Anwendungsbereitstellung und -sicherheit", id: "Application delivery and security" },
        { name: "Citrix und Google", id: "Citrix and Google" },
        { name: "Citrix und Microsoft", id: "Citrix and Microsoft" },
        { name: "Cloud-Migration", id: "Cloud migration" },
        { name: "Vergleichen", id: "Compare" },
        { name: "Content collaboration", id: "Content collaboration" },
        { name: "Digitale Arbeitsplätze", id: "Digital workspaces" },
        { name: "Mitarbeiterkomfort", id: "Employee experience" },
        { name: "Hybrid cloud", id: "Hybrid cloud" },
        { name: "Hybride Arbeit", id: "Hybrid work" },
        { name: "Verwalten und optimieren", id: "Manage and optimize" },
        { name: "Microservices und DevOps", id: "Microservices and devOps" },
        { name: "Onboarding und Annahme", id: "Onboarding and adoption" },
        { name: "Parnerintegrationen", id: "Partner integrations" },
        { name: "Produktübersicht", id: "Product overview" },
        { name: "Sicherheit und Compliance", id: "Security and compliance" },
        { name: "Kleine Unternehmen", id: "Small business" },
        { name: "Technische Daten", id: "Specifications" },
        { name: "Nachhaltigkeit", id: "Sustainability" },
        { name: "Einheitliches Endgeräte-Management", id: "Unified endpoint management" },
        { name: "VDI und DaaS", id: "VDI and DaaS" },
      ],
    }, 
    Type: {
      label: 'Typ',
      allFilterLabel: "Alle Arten",
      items: [
        { name: "Analystenbericht", id: "Analyst report" },
        { name: "Bewertungstool", id: "Assessment tool" },
        { name: "Kundenreferenz", id: "Customer story" },
        { name: "Datenblatt", id: "Data sheet" },
        { name: "Demo", id: "Demo" },
        { name: "e-Book", id: "eBook" },
        { name: "Anleitungen", id: "Guide" },
        { name: "Infografik", id: "Infographic" },
        { name: "Interaktive Tour", id: "Interactive tour" },
        { name: "Podcast", id: "Podcast" },
        { name: "Ressourcen-Kit", id: "Resource kit" },
        { name: "Lösungsbeschreibung", id: "Solution brief" },
        { name: "Technisches Briefing", id: "Technical brief" },
        { name: "Video", id: "Video" },
        { name: "Webinar", id: "Webinar" },
        { name: "Whitepaper", id: "White paper" },
      ],
    },
    Industry: {
      label: "Branche",
      allFilterLabel: "Alle Arten",
      items: [
        { name: "Bildung", id: "education" },
        { name: "Finanzdienstleistungen", id: "financial_service" },
        { name: "Öffentliche Verwaltung", id: "government" },
        { name: "Gesundheitswesen", id: "healthcare" },
        { name: "Produktion", id: "manufacturing" },
        { name: "Medien & Inhalte", id: "media_and_content" },
        { name: "Einzelhandel", id: "retail" }
      ],
    }
  },
    searchPlaceholder: "Bibliothek durchsuchen",
    titles : {
      label1: "Jetzt im Trend",
      label2: "Aktuelle Ressourcen",
      label3: "Kürzlich angesehen",
      label4: "Empfohlene Ressourcen"
    },
    showMoreLabel: "Mehr anzeigen",
    clearAllSelected: "Gesamte Auswahl löschen",
    searchResults: "Suchergebnisse für",
    clearAllFilters: "Alle Filter löschen",
    noResultsFound: "Keine Ressourcen für die von Ihnen ausgewählten Kriterien vorhanden",
    resetView: "Ansicht zurücksetzen",
    filterLabel: "Filter",
    filteredRes: "Suchergebnisse",
    filterRes: "Ergebnisse filtern",
    clearAllCta: "Alle löschen",
    applyCta: "Anmelden",
    view: "Anzeigen",
    includeEnglishRes: "Englischsprachige Ressourcen anzeigen"
  };
